<template>
  <div>
    <WdsText class="tw-mb-4" :text="title" />
    <WdsRadioGroup v-model:checked="internalModelValue" :name="name">
      <WdsRadio :disabled="disabled" :value="0">
        <WdsText :text="textNo" />
      </WdsRadio>

      <WdsRadio :disabled="disabled" :value="1">
        <WdsText :text="textYes" />
      </WdsRadio>
    </WdsRadioGroup>
  </div>
</template>

<script>
/* eslint-disable import/extensions */
import { WdsRadio, WdsRadioGroup, WdsText } from '@worksome/wds-components'
import { computed } from 'vue'
import { booleanToIntNullable, intToBooleanNullable } from '@/utils/forms/ValueNormalisers'
import { useMarketDependentValue } from '@/composables/markets'
import { $t } from '@/composables/translation'

export default {
  components: {
    WdsRadio,
    WdsRadioGroup,
    WdsText,
  },
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    market: {
      type: String,
      default: null,
    },
    modelValue: {
      type: String,
      required: true,
    },
    name: {
      type: String,
      default: 'is_vat_registered',
    },
  },
  setup(props, { emit }) {
    const internalModelValue = computed({
      get() {
        return booleanToIntNullable(props.modelValue)
      },
      set(modelValue) {
        emit('update:modelValue', intToBooleanNullable(modelValue))
      },
    })

    const { marketValue: title } = useMarketDependentValue(
      props.market,
      {
        AU: $t('Are you registered for GST?'),
        CA: $t('Are you registered for GST/HST?'),
        DE: $t('Are you subject to VAT (Umsatzsteuer)?'),
        SG: $t('Are you registered for GST?'),
        US: $t('Are you registered for Sales Tax?'),
      },
      $t('Are you subject to VAT?'),
    )

    const { marketValue: textNo } = useMarketDependentValue(
      props.market,
      {
        AU: $t('No, I will be billing without GST'),
        CA: $t('No, I will be billing without GST/HST'),
        SG: $t('No, I will be billing without GST'),
        US: $t('No, I will be billing without Sales Tax'),
      },
      $t('No, I am not subject to VAT'),
    )

    const { marketValue: textYes } = useMarketDependentValue(
      props.market,
      {
        AU: $t('Yes, I have a GST registration'),
        CA: $t('Yes, I have a GST/HST registration'),
        SG: $t('Yes, I have a GST registration'),
        US: $t('Yes, I have a Sales Tax registration'),
      },
      $t('Yes, I am subject to VAT'),
    )

    return {
      internalModelValue,
      textNo,
      textYes,
      title,
    }
  },
}
</script>
